import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class NavService {

  private navState = new Subject<boolean>();

  openNav(status: boolean) {
    this.navState.next(status);
  }

  getStatus(): Observable<any> {
    return this.navState.asObservable();
  }
}
